/**
 * @generated SignedSource<<5c7d01fb52deaa5cefe466feb9a8e729>>
 * @relayHash b75121084378e2e0f34ed1876ee0ac92
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/491.0.0-2024-12-04T08:42:30.904Z/GetHelpZendeskSendMessageFormMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateContactRequestMutationInput = {
  attachment?: any | null;
  buyerId?: string | null;
  clientMutationId?: string | null;
  conversationId?: string | null;
  email?: string | null;
  itemPk?: string | null;
  message?: string | null;
  name?: string | null;
  orderId?: string | null;
  sellerId?: string | null;
  subtopic?: string | null;
  topic?: string | null;
  url?: string | null;
};
export type GetHelpZendeskSendMessageFormMutation$variables = {
  input: CreateContactRequestMutationInput;
};
export type GetHelpZendeskSendMessageFormMutation$data = {
  readonly CreateContactRequestMutation: {
    readonly recordId: string | null;
  } | null;
};
export type GetHelpZendeskSendMessageFormMutation = {
  response: GetHelpZendeskSendMessageFormMutation$data;
  variables: GetHelpZendeskSendMessageFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateContactRequestMutationPayload",
    "kind": "LinkedField",
    "name": "CreateContactRequestMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recordId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskSendMessageFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskSendMessageFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/491.0.0-2024-12-04T08:42:30.904Z/GetHelpZendeskSendMessageFormMutation",
    "metadata": {},
    "name": "GetHelpZendeskSendMessageFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "08fd8ae4d8f636997b3d07c3e90b447f";

export default node;
